<template>
  <div :class="['dlgn', `dlgn-${tone}`]" :role="tone === 'danger' ? 'alert' : 'status'">
    <i :class="resolvedIcon" class="dlgn-icon" aria-hidden="true"></i>
    <div class="dlgn-text">
      <p v-if="title" class="dlgn-title">{{ title }}</p>
      <div class="dlgn-body"><slot></slot></div>
    </div>
  </div>
</template>

<script setup>
/**
 * BANDEAU EN TÊTE DE CORPS.
 *
 * Une erreur de serveur n'est pas un toast : un toast s'efface au bout de
 * quelques secondes alors que le problème, lui, est toujours là et que la
 * fenêtre est toujours ouverte. Elle se pose donc AU-DESSUS des champs, et y
 * reste tant que l'appelant ne l'a pas retirée — la saisie, elle, ne bouge pas.
 *
 * Dix modales rendaient ce bandeau à la main, chacune avec ses propres teintes.
 */
import { computed } from 'vue'

const props = defineProps({
  tone: {
    type: String,
    default: 'info',
    validator: (v) => ['info', 'warning', 'danger', 'success'].includes(v)
  },
  title: { type: String, default: null },
  icon: { type: String, default: null }
})

const ICONS = {
  info: 'fas fa-info-circle',
  warning: 'fas fa-exclamation-triangle',
  danger: 'fas fa-exclamation-triangle',
  success: 'fas fa-check-circle'
}

const resolvedIcon = computed(() => props.icon || ICONS[props.tone])
</script>

<style scoped>
.dlgn {
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-2);
  padding: var(--spacing-3) var(--spacing-3);
  border: 1px solid transparent;
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  line-height: var(--line-height-normal);
}

.dlgn-icon {
  flex: 0 0 auto;
  margin-top: 2px;
  font-size: var(--font-size-base);
}

.dlgn-text {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.dlgn-title {
  margin: 0;
  font-weight: var(--font-weight-semibold);
}

.dlgn-body { min-width: 0; }

.dlgn-info {
  background: var(--color-info-lightest);
  border-color: #d6e9f7;
  color: var(--color-info-darker);
}

.dlgn-warning {
  background: var(--color-warning-lightest);
  border-color: #fdeeba;
  color: #8a5a00;
}

.dlgn-danger {
  background: var(--color-danger-lightest);
  border-color: var(--color-danger-lighter);
  color: var(--color-danger-dark);
}

.dlgn-success {
  background: var(--color-success-lightest);
  border-color: #c7ecd6;
  color: var(--color-success-darker);
}
</style>
